import { render, staticRenderFns } from "./userPicker.vue?vue&type=template&id=45759bf5&scoped=true"
import script from "./userPicker.vue?vue&type=script&lang=js"
export * from "./userPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45759bf5",
  null
  
)

export default component.exports